import {tokens} from '@sail/ui';
import {CssValue} from '@sail/engine/deprecated';
import {IconAsset} from '@sail/icons/types';
import {stripe} from '@sail/icons/react/BrandIcon';

export interface Theme {
  brandColor: string;
  onBrandTextColor: string;
  ctaColor: string;
  ctaDisabledOpacity?: string;
  ctaHoverColor: string;
  onCtaTextColor: string;
  onActionPrimaryTextColor?: string;
  textColor: string;
  linkColor: string;
  avatarGradientStart?: string;
  avatarGradientEnd?: string;
  headerBarGradient?: string;
  focusVisibleOutline?: CssValue<string>;
  icon: IconAsset;
  messageKey?: string;
  surfaceHoverColor: string;
  secondaryButtonBackground?: string;
  secondaryButtonFontWeight?: string;
  articleHeadingsColor: string;
  articleLinkColor: string;
  primaryActionColor: string;
  primaryActionActiveColor?: string;
  primaryActionActiveTextColor?: string;
  primaryActionColorHoveredKeyline?: string;
  primaryActionDisabledColor?: string;
  primaryActionShadow?: string;
  primaryActionShadowHovered?: string;
  pressedShadow: string;
  hoverBoxShadow?: string;
  buttonBackgroundImage: string;
  buttonBorderWidth: string;
  buttonHoverColor: string;
  messageBubbleText: string;
  messageBubbleBackground: string;
  assistantIconColor0?: string;
  assistantIconColor1?: string;
  assistantHeaderTitle?: string;
  linkBrandName?: string;
  audience?: string;
  formBorderColor: string;
  cardBorderRadius?: string;
  formTitleLabelMarginBottom?: string;
  formTitleFontSize?: string;
  formTitleFontWeight?: string;
  formTitleLineHeight?: string;
  formTitleColor?: string;
  textFieldBackgroundColor?: string;
  textFieldFocusBackgroundColor?: string;
  textFieldBorder?: string;
  textFieldBoxShadow?: string;
  textFieldBorderRadius?: string;
  textFieldPlaceholderColor?: string;
  textFieldPlaceholderFontSize?: string;
  textFieldFocusBorder?: string;
  textFieldFocusBorderColor?: string;
  submitButtonPadding?: string;
  submitButtonBorderRadius?: string;
  submitButtonDisabledBackground?: string;
  submitButtonDisabledColor?: string;
  focusRing?: string;
  feedbackThumbColor?: string;
  useCustomPlaceholder?: boolean;
  textFieldPaddingTop?: string;
  textFieldPaddingBottom?: string;
  textFieldPaddingLeft?: string;
  textFieldPaddingRight?: string;
  textFieldLineHeight?: string;
  textFieldHeight?: string;
  textFieldFontSize?: string;
  textFieldFontWeight?: string;
  customPlaceholderColor?: string;
  customPlaceholderTopFocused?: string;
  customPlaceholderTopUnfocused?: string;
  customPlaceholderLeft?: string;
  customPlaceholderFontSizeFocused?: string;
  customPlaceholderFontSizeUnfocused?: string;
  customPlaceholderTransition?: string;
  customPlaceholderFontWeight?: string;
  textCaretColor?: string;
}

export const DefaultTheme: Theme = {
  brandColor: tokens.color.primary[500].toString(),
  onBrandTextColor: '$color.neutral100',
  ctaColor: '$color.brand500',
  ctaDisabledOpacity: '0.5',
  ctaHoverColor: '$hue.purple600',
  onCtaTextColor: '$color.neutral100',
  onActionPrimaryTextColor: tokens.color.neutral[0].toString(),
  textColor: '$color.text',
  linkColor: '$color.brand500',
  avatarGradientStart: '$color.brand400',
  avatarGradientEnd: '$color.brand600',
  icon: stripe,
  surfaceHoverColor: tokens.color.background.offset.toString(),
  secondaryButtonBackground: tokens.color.background.offset.toString(),
  secondaryButtonFontWeight: 'semibold',
  articleHeadingsColor: '#000000',
  articleLinkColor: 'action.primary',
  primaryActionColor: tokens.color.primary[500].toString(),
  primaryActionActiveColor: tokens.color.primary[600].toString(),
  primaryActionActiveTextColor: tokens.color.primary[100].toString(),
  primaryActionColorHoveredKeyline: tokens.color.primary[700].toString(),
  primaryActionDisabledColor: tokens.color.neutral[0].toString(),
  primaryActionShadow: 'action.primary',
  pressedShadow: 'action.primary.pressed',
  primaryActionShadowHovered: 'action.primary.hovered',
  hoverBoxShadow:
    '0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(48, 49, 61, 0.08)',
  buttonBackgroundImage:
    'linear-gradient(white, white), linear-gradient(to right, #675DFF 0%, #55DDFF 105%)',
  buttonBorderWidth: '1.5px',
  buttonHoverColor: 'action.primary',
  messageBubbleBackground: tokens.color.neutral[50].toString(),
  messageBubbleText: tokens.color.neutral[800].toString(),
  assistantIconColor0: 'url(#paint0_linear_757_90506)',
  assistantIconColor1: 'url(#paint1_linear_757_90506)',
  assistantHeaderTitle: 'Assistant',
  audience: 'stripe',
  formBorderColor:
    'linear-gradient(45deg, #55DDFF -20.36%, #675DFF 54.28%, #28239B 125.93%)',
  formTitleLabelMarginBottom: 'medium',
  formTitleFontSize: '16px',
  formTitleFontWeight: 'bold',
  formTitleLineHeight: '24px',
  formTitleColor: 'text',
  submitButtonPadding: '4px 8px',
  submitButtonBorderRadius: 'action',
  focusRing: '0 0 0 4px rgba(1, 150, 237, .36)',
  feedbackThumbColor: tokens.color.primary[500].toString(),
  cardBorderRadius: '8px',
  useCustomPlaceholder: false,
  textFieldBackgroundColor: tokens.color.neutral[0].toString(),
  textFieldFocusBackgroundColor: tokens.color.neutral[0].toString(),
  textFieldFocusBorder: '1px solid',
  textFieldBorder: '1px solid',
  textFieldFocusBorderColor: '#D8DEE4',
  textFieldBorderRadius: '6px',
  textFieldPaddingTop: undefined,
  textFieldPaddingBottom: undefined,
  textFieldPaddingLeft: undefined,
  textFieldPaddingRight: undefined,
  textFieldLineHeight: undefined,
  textFieldHeight: undefined,
  textFieldFontSize: undefined,
  textFieldFontWeight: undefined,
};
